// Copyright 2025, University of Maryland, All Rights Reserved
import { Navigate } from 'react-router-dom';
import { useAuth } from '@umd-dit-ai-workspace/workspaces-component';
import { ReactNode } from 'react';

interface ProtectedAdminRouteProps {
  children: ReactNode;
}

export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { isAdmin, isLoading } = useAuth();

  // If we're still loading the auth state, render nothing yet
  if (isLoading) {
    return null;
  }

  // If user is not admin, redirect to bills page
  if (!isAdmin) {
    return <Navigate to="/bills" replace />;
  }

  // Otherwise render the admin content
  return <>{children}</>;
}
